import axios from 'axios';
import { toast } from 'react-toastify';

// Default production API URL
const DEFAULT_API_URL = 'https://idealonline.com.tr/service/idealonline/v1/';

// Resolve API URL in this order:
// 1. REACT_APP_API_URL (set in env for local/dev overrides)
// 2. window.__IDEAL_API_URL__ (optional runtime override)
// 3. fallback to DEFAULT_API_URL
const getDynamicBaseUrl = () => {
  // 1. Local Geliştirme (localhost) durumu
  if (typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return process.env.REACT_APP_API_URL || 'https://idealonline.com.tr/service/idealonline/v1/';
  }

  // 2. Ezproxy veya Canlı Domain Durumu
  // window.location.origin => "https://www-idealonline-com-tr.offcampus.ihu.edu.tr" verir.
  if (typeof window !== 'undefined') {
    const origin = window.location.origin;
    // URL'nin sonuna standart servis yolunu ekliyoruz
    return `${origin}/service/idealonline/v1/`;
  }

  return 'https://idealonline.com.tr/service/idealonline/v1/';
};

export const API_URL = getDynamicBaseUrl();

export const getFilePath = (path) => {
  if (!path) return "";
  if (path.startsWith('http')) return path; // Zaten tam linkse dokunma

  // Başındaki olası slash'ı temizle ve API_URL ile birleştir
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${API_URL}${cleanPath}`;
};

const axiosInstance = axios.create({
  baseURL: getDynamicBaseUrl(),
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Read auth at the time of handling the error to avoid stale data
    const auth = JSON.parse(localStorage.getItem('auth') || '{}');

    if (error && error.response) {
      const status = error.response.status;

      if (status === 401) {
        // Allow override of logout URL via env if desired
        const origin = window.location.origin;
        const message = error.response.data?.message || "";
        window.location.href = `${origin}/logout?reason=401${message ? `&message=${encodeURIComponent(message)}` : ""}`;
        return Promise.reject(error);
      }

      if (status === 405 && auth.rolename !== 'ADMIN') {
        toast.error(error.response.data?.message || 'Unauthorized action');
      }
    }

    console.error('axios error response:', error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
